import { render } from "./Numbers.vue?vue&type=template&id=1b1b24db&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"

import "./Numbers.vue?vue&type=style&index=0&id=1b1b24db&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1b24db"]])

export default __exports__